import { Button, ColumnsType } from '@seiue/ui'
import { DataTable, TableQuery } from 'packages/components/DataTable'
import { GrowpIcon } from 'packages/components/GrowpIcon'
import { Entryrecord, reflectionApi } from 'packages/sdks-next/growp'
import { AnyType } from 'packages/types'
import { entryrecordTypeToLabel } from 'packages/utils'
import styled from 'styled-components'

/**
 * 账号管理-登录日志
 * 
 * @param param0 - 参数
 * @param param0.tabClick - 点击tab
 * @returns React.FC
 */
export const LoginLog: React.FC<{
  tabClick: (key: string) => void
}> = ({ tabClick }) => {
  const columns: ColumnsType<AnyType> = [
    {
      title: '登录方式',
      key: 'loginType',
      render: (v: Entryrecord) => entryrecordTypeToLabel.get(v.loginType),
    },
    {
      title: '设备',
      key: 'device',
      dataIndex: 'device',
    },
    {
      title: '系统',
      key: 'os',
      dataIndex: 'os',
    },
    {
      title: 'IP',
      key: 'ip',
      dataIndex: 'ip',
    },
    {
      title: '浏览器',
      key: 'browser',
      dataIndex: 'browser',
    },
    {
      title: '地址',
      key: 'address',
      dataIndex: 'address',
    },
    {
      title: '登录时间',
      key: 'operatedAt',
      dataIndex: 'operatedAt',
    },
  ]

  // 默认查询6个月前的数据
  const currentDate = new Date()
  const operatedAtEgt = currentDate
    .setMonth(currentDate.getMonth() - 6)
    .toLocaleString()

  return (
    <Wrapper>
      <TitleWrapper>登录日志</TitleWrapper>
      <InfoWrapper>
        <GrowpIcon
          name="InfoCircleFill"
          size={16}
          color="#0A6CFF"
        />
        <InfoText>
          以下是近 6 个月的登录记录，若存在异常情况，请尽快{' '}
          <Button
            type="link"
            onClick={() => tabClick('modifyassword')}
          >
            修改密码
          </Button>
        </InfoText>
      </InfoWrapper>
      <DataTable
        rowKey={'operatedAt'}
        columns={columns}
        api={(q: TableQuery) => {
          return reflectionApi.queryMeEntryrecords({
            ...q,
            operatedAtEgt: operatedAtEgt,
            sort: '-operatedAt',
          })
        }}
        isPagination={true}
        showSearchForm={false}
        apiName="reflection.queryMeEntryrecords"
      />
    </Wrapper>
  )
}

const Wrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  padding: 20px 20px 0px 0px;
  overflow: scroll;
  height: calc(100vh - 110px);
`

const TitleWrapper = styled.div`
  width: 80px;
  height: 28px;
  font-size: 20px;
  font-weight: 500;
  line-height: 28px;
  margin-bottom: 8px;
  color: ${(props) => props.theme.text._1};
`

const InfoWrapper = styled.div`
  height: 40px;
  border-radius: 8px;
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 9px 16px;
  gap: 8px;
  align-self: stretch;
  background: #e8f5ff;
`

const InfoText = styled.div`
  color: ${(props) => props.theme.text._1};
  font-size: 14px;
  font-weight: normal;
  line-height: 22px;
  letter-spacing: 0em;
`
